<app-main-page>
  <div desktopTitle>
    Yksityisyys
  </div>
  <app-privacy></app-privacy>
</app-main-page>